//
//  SDKTokenType.ts
//  Supernova SDK
//
//  Created by Jiri Trecak.
//
// --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- ---
// MARK: - Token type enum
export var TokenType;
(function (TokenType) {
    TokenType["color"] = "Color";
    TokenType["typography"] = "Typography";
    TokenType["shadow"] = "Shadow";
    TokenType["border"] = "Border";
    TokenType["gradient"] = "Gradient";
    TokenType["blur"] = "Blur";
    TokenType["radius"] = "BorderRadius";
    TokenType["borderWidth"] = "BorderWidth";
    TokenType["duration"] = "Duration";
    TokenType["fontSize"] = "FontSize";
    TokenType["dimension"] = "Dimension";
    TokenType["letterSpacing"] = "LetterSpacing";
    TokenType["lineHeight"] = "LineHeight";
    TokenType["opacity"] = "Opacity";
    TokenType["paragraphSpacing"] = "ParagraphSpacing";
    TokenType["size"] = "Size";
    TokenType["space"] = "Space";
    TokenType["zIndex"] = "ZIndex";
    TokenType["textDecoration"] = "TextDecoration";
    TokenType["textCase"] = "TextCase";
    TokenType["visibility"] = "Visibility";
    TokenType["fontFamily"] = "FontFamily";
    TokenType["fontWeight"] = "FontWeight";
    TokenType["string"] = "String";
    TokenType["productCopy"] = "ProductCopy";
})(TokenType || (TokenType = {}));
export const STRING_TOKEN_TYPES = [
    TokenType.string,
    TokenType.productCopy,
    TokenType.fontFamily,
    TokenType.fontWeight,
];
export const OPTION_TOKEN_TYPES = [
    TokenType.textCase,
    TokenType.textDecoration,
    TokenType.visibility,
];
export const DIMENSION_TOKEN_TYPES = [
    TokenType.dimension,
    TokenType.size,
    TokenType.space,
    TokenType.opacity,
    TokenType.fontSize,
    TokenType.lineHeight,
    TokenType.letterSpacing,
    TokenType.paragraphSpacing,
    TokenType.borderWidth,
    TokenType.radius,
    TokenType.duration,
    TokenType.zIndex,
];
export const RAW_DIMENSION_TOKEN_TYPES = [
    TokenType.opacity,
    TokenType.zIndex,
];
export const MS_DIMENSION_TOKEN_TYPES = [TokenType.duration];
export const ALL_TOKEN_TYPES = [
    ...DIMENSION_TOKEN_TYPES,
    ...STRING_TOKEN_TYPES,
    ...OPTION_TOKEN_TYPES,
    TokenType.color,
    TokenType.gradient,
    TokenType.border,
    TokenType.radius,
    TokenType.shadow,
    TokenType.typography,
    TokenType.blur,
];
export const PURE_TOKEN_TYPES = [
    ...DIMENSION_TOKEN_TYPES,
    ...STRING_TOKEN_TYPES,
    ...OPTION_TOKEN_TYPES,
];
export const tokenTypeIsPure = (tokenType) => {
    return PURE_TOKEN_TYPES.includes(tokenType);
};
export const tokenTypeIsNonPure = (tokenType) => {
    return !tokenTypeIsPure(tokenType);
};
export const REPLACABLE_TOKEN_TYPES = [
    TokenType.color,
    ...DIMENSION_TOKEN_TYPES,
    ...STRING_TOKEN_TYPES,
    ...OPTION_TOKEN_TYPES, // FIXME: Should they be here
];
export const REFERENCABLE_TOKEN_TYPES = [
    TokenType.color,
    ...DIMENSION_TOKEN_TYPES,
    TokenType.fontFamily,
    TokenType.fontWeight,
    TokenType.textCase,
    TokenType.textDecoration,
];
export const tokenTypeIsReferencable = (tokenType) => {
    return REFERENCABLE_TOKEN_TYPES.includes(tokenType);
};
export const DT_TOKEN_TYPES = [
    TokenType.color,
    TokenType.shadow,
    TokenType.gradient,
    TokenType.typography,
    TokenType.border,
    ...DIMENSION_TOKEN_TYPES,
    TokenType.fontFamily,
    TokenType.fontWeight,
    TokenType.string,
    ...OPTION_TOKEN_TYPES,
];
